const getCommasNumber = (
    value: string,
    end: number | undefined,
    start: number = 0
): number => {
    return (value.substring(start, end).match(/,/g) || []).length;
};

export { getCommasNumber };
